export function parseStringToNumber(value: string) {
  const int = parseInt(value, 10);

  if (!isNaN(int) && Number.isInteger(int)) {
    return int;
  }
  return null;
}
